import { type FC } from "react";

import { cx } from "@emotion/css";
import { type ButtonType } from "@snapchat/snap-design-system";

import { makeBusinessManagerUrl } from "../../../core/routes/utils";
import { useSelectedOrganizationAndLensFolderV3 } from "../../../shared/hooks";
import { linkButtonDefaultClassName } from "../../../shared/styles";

import { GoToBusinessManager } from "./messages.generated";

interface BusinessManagerButton {
    className?: string;
    type?: ButtonType;
}

export const BusinessManagerButton: FC<BusinessManagerButton> = ({ className }) => {
    const { orgId, lensFolderId } = useSelectedOrganizationAndLensFolderV3();

    if (!orgId || !lensFolderId) {
        return null;
    }

    const businessManagerUrl = makeBusinessManagerUrl(orgId, lensFolderId);

    return (
        <a
            href={businessManagerUrl}
            target="_blank"
            rel="noreferrer"
            className={cx(linkButtonDefaultClassName, className)}
        >
            <GoToBusinessManager />
        </a>
    );
};
